import * as v from 'valibot';
import { CommonValueSchema } from '../types/CommonValue';
import { entityStateUpdated } from '../reducers/entityStatesSlice';
export function entityStateEvent(entityID, etype, value, ts) {
    return (dispatch) => {
        const res = v.safeParse(CommonValueSchema, { type: etype.name, value });
        if (res.success) {
            const d = res.output;
            dispatch(entityStateUpdated({ entity_id: entityID, value: d, ts }));
        }
    };
}
